import React, { Component } from "react";
import glamorous, { Div, Span } from "glamorous";
import SearchLocationInput from "./SearchLocationInput";
import { extractLocationData } from "../../../common";
import Select from "../../common/Select";
import { dimensions } from "../../../style/index"

const SearchContainer = glamorous.div({
  height: 180,
  fontFamily: "'PT Serif', serif",
  fontSize: 24,
  background: "url(https://s3.amazonaws.com/mstravel/prod/images/webapp/search_input.jpg)",
  backgroundPosition: "center",
  position: "relative",
  [dimensions.SCREEN_MAX_SM] : {
    height: 82
  }
})

const Search = glamorous.div({
  height: 82,
  background: "rgba(68,59,92,0.75)",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  [dimensions.SCREEN_MAX_SM] : {
    flexDirection: "column",
    alignItems: "flex-start",
    paddingLeft: 20
  }
})

const Bar = glamorous.div({
  position: "absolute",
  width: "100%",
  bottom: 0,
  [dimensions.SCREEN_MAX_SM] : {
    paddingTop: 0
  }
})

const Icon = glamorous.span({
  marginRight: 10,
  [dimensions.SCREEN_MAX_SM]: {
    display: "none"
  }
})

const Text = glamorous.span({
  flexShrink: 0,
  [dimensions.SCREEN_MAX_XXS]: {
    fontSize: 22,
    lineHeight: "32px"
  }
})

const searchIcon = (
  <svg width='34' height='34' viewBox='0 0 22 22' xmlns='http://www.w3.org/2000/svg'>
      <g id='Page-1' fill='none' fillRule='evenodd'>
          <g id='Search---Results---People' transform='translate(-88 -114)' fill='#979797'>
              <g id='Search' transform='translate(0 60)'>
                  <g id='Sentence-Copy' transform='translate(88 48)'>
                      <path d='M21.70725,20.293 L16.032,14.61775 C17.26375,13.078 18,11.125 18,9 C18,4.0295 13.97075,0 9,0 C4.0295,0 0,4.0295 0,9 C0,13.9705 4.0295,18 9,18 C11.125,18 13.078,17.2635 14.61775,16.03175 L20.293,21.707 C20.48825,21.90225 20.74425,22 21,22 C21.256,22 21.512,21.90225 21.70725,21.707 C22.09775,21.31675 22.09775,20.68325 21.70725,20.293 L21.70725,20.293 Z M9,16 C5.134,16 2,12.866 2,9 C2,5.134 5.134,2 9,2 C12.86625,2 16,5.134 16,9 C16,12.866 12.86625,16 9,16 L9,16 Z'
                      transform='translate(0 6)' id='Shape' />
                  </g>
              </g>
          </g>
      </g>
  </svg>
)

class SearchHomeInput extends Component {

constructor(props) {
  super(props);

  this.state = {
      formData: {},
  };
  this.runSearchIfReady = this.runSearchIfReady.bind(this);
  this.saveLocation = this.saveLocation.bind(this);
  this.filterTypeChangeHandler = this.filterTypeChangeHandler.bind(this);
  }
    
  saveLocation = (place) => {
    // apply location to state
    let loc = extractLocationData(place);
    this.setState({formData: { ...loc}}, () => {
        // save location to filters
        // apply to search
        this.runSearchIfReady();
    });

  }

  filterTypeChangeHandler = (e) => {
      // save in current state
      let filterMembersLivingIn = Boolean(e.target.value === "true");
      this.setState({filterMembersLivingIn},() => {
          this.runSearchIfReady();
      });
  }

  runSearchIfReady = () => {
    // runs the search if ready
    let { formData, filterMembersLivingIn } = this.state;
    if(formData.city && filterMembersLivingIn != undefined) {
      this.props.dropInSearchResults(filterMembersLivingIn,formData);
    }
  }

  render() {
    return (
      <SearchContainer>
        <Bar>
          <Search>
            <Div display="flex" height={36}>
              <Icon marginRight="10px" >{searchIcon}</Icon>
              <Text>I am looking for &nbsp;</Text>
              <Select
                onChange={this.filterTypeChangeHandler}
                arrow="light"
                dropdownStyle="mt-purple"
                dropdownStyleOptions={{width:122}}
              >
                <option value="" disabled selected style={{color: 'green'}}>Pick One</option>
                <option value={true}>People</option>
                <option value={false}>Trips</option>
              </Select>
              &nbsp;
              &nbsp;
              </Div>
            <Div display="flex" height={36}>
              <Text>{this.state.filterMembersLivingIn ? 'in' : 'to'} &nbsp;</Text>
              <SearchLocationInput
                saveLocation={this.saveLocation}
                searchFilters={{}}
                filterMembersLivingIn={true}
              />
            </Div>
          </Search>
        </Bar>
      </SearchContainer>
    );
  }
}

export default SearchHomeInput;



// WEBPACK FOOTER //
// ./src/components/pages/Search/SearchHomeInput.jsx